import { useQuery } from '@tanstack/react-query';
import { getSsoCapabilities, type SsoCapabilities } from '../services';

/**
 * Returns the current user's SSO Admin capabilities as reported by the
 * backend at /api/v2/sso/capabilities/. Drives sidebar gating and guard
 * checks.
 *
 * Tiaki staff see all configurations regardless of the SSO Admin group.
 */
export function useSsoCapabilities() {
  return useQuery<SsoCapabilities>({
    queryKey: ['sso', 'capabilities'],
    queryFn: getSsoCapabilities,
    staleTime: 60_000,
  });
}

export function hasSsoAdminAccess(caps: SsoCapabilities | undefined): boolean {
  if (!caps) return false;
  return Boolean(caps.is_staff || caps.is_sso_admin);
}
